import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LogList from "../components/Logs/LogList"
import { fetchLogsCount, fetchLogs } from "../actions/logs";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  const { logs } = state; 

  return {
    isFetching: logs.isFetching,
    searchCount: logs.searchCount,
    searchKeys: logs.searchKeys,
    logs_data: logs.data,
    error: logs.error,
    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchLogsCount,
      fetchLogs,
      fetchUserInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LogList);
